<template>
  <div class="price-warp">
    <div :style="[priceTagStyle]" class="scale-font">¥</div>
    <div :style="[priceTagStyle]" class="base-scale">{{ numberInteger }}</div>
    <div :style="[priceTagStyle]" v-if="numberDecimals">.</div>
    <div :style="[priceTagStyle]" class="scale-font">{{ numberDecimals }}</div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#EE3721",
    },
    baseFountSize: {
      type: String,
      default: "5.3333vw",
    },
    number: {
      default: "",
    },
  },
  data() {
    return {};
  },

  // 计算属性
  computed: {
    priceTagStyle() {
      return {
        color: this.color,
        "font-size": this.baseFountSize,
      };
    },
    numberInteger() {
      return this.number.toString().split(".")[0];
    },
    numberDecimals() {
      return this.number.toString().split(".")[1];
    },
  },
};
</script>
<style lang="scss" scoped>
.price-warp {
  display: flex;
  align-items: flex-end;
  line-height: 1;
  // width: 90%;
  // margin-top: 13px;
  float: left;
  margin-right: 10px;
}
.base-scale {
  transform: scale(1);
  transform-origin: center bottom;
}

.scale-font {
  transform: scale(0.7);
  transform-origin: center bottom;
}
</style>
